import { render, staticRenderFns } from "./CustomizeDashboard.vue?vue&type=template&id=4ec3b4f7&scoped=true&"
import script from "./CustomizeDashboard.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomizeDashboard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec3b4f7",
  null
  
)

export default component.exports